import { GET_WAREHOUSE_TABS, convertResult } from 'app/common/api/requests/food/warehouse/tabs/get'
import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'
import { WarehouseTabs } from 'app/common/types/warehouse/tabs'

const defaultState: WarehouseTabs = new Map()

type Op = CommonDataOptions<WarehouseTabs, void>

export function useWarehouseTabs(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_WAREHOUSE_TABS,
    error: 'Не удалось получить настройки склада',
    convertions: {
      convertResult,
    },
    defaultState,
  })

  return res
}
